import { Component, Input } from '@angular/core';
import { EnvelopeDTO } from '../../api/plyca-dtos-v2';

@Component({
  selector: 'envelope-status-table',
  templateUrl: 'envelopeStatusTable.template.html'
})
export class EnvelopeStatusTableComponent {

  /**
   *  Lista de objetos de tipo EnvelopeDTO que debera tener las propiedades
   * deciphered: numero de ofertas descifradas
   * noDeciphered: numero de ofertas no descifradas
   * validated: numero de ofertas validadas
   * total: total de ofertas
   */
  @Input()
  envelopes: Array<EnvelopeDTO>;

  @Input()
  inProgress = true;
}
